import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import DraftingServices from './components/DraftingServices';
import ProcessSection from './components/ProcessSection';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import ToolsSection from '../../components/feature/ToolsSection';
import SEO from '../../components/base/SEO';

export default function ServicesPage() {

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <SEO 
        title="Drafting Services | Drafting By DMI"
        description="Precision CAD & BIM solutions including architectural floor plans, 3D renderings, and comprehensive drafting services."
        url={window.location.href}
      />
      <Header />
      <main>
        <DraftingServices />
        <ToolsSection />
        <ProcessSection serviceType="drafting" />
        <ComparisonSection />
        <CTASection serviceType="drafting" />
      </main>
      <Footer />
    </div>
  );
}